import { useState } from "react";
import {
  Box as MuiBox,
  Link as MuiLink,
  IconButton as MuiIconButton,
  Typography as MuiTypography,
} from "@mui/material";
import {
  UnfoldLess as MuiUnfoldLessIcon,
  UnfoldMore as MuiUnfoldMoreIcon,
} from "@mui/icons-material";
import { Trans } from "react-i18next";
import { Theme, useBrowserStorage } from "common";
import { STORAGE_NAMES, STORAGE_TYPE } from "app/shared/constants";
import { INSTRUCTIONS_LINKS } from "app/services/StudyRecruitmentService/constants";

const boxStyles = {
  padding: "16px",
  backgroundColor: Theme.palette.primary.contrastText,
  borderRadius: "8px",
  boxShadow: "rgba(0, 0, 0, 0.1) 1px 1px 3px 0.2px",
  width: "1150px",
};

const textStyles = {
  fontSize: "17px",
  lineHeight: "20px",
  whiteSpace: "pre-wrap",
};

const StudyRecruitmentInstructions = () => {
  const { getItem, saveItem } = useBrowserStorage(STORAGE_TYPE.LOCAL);
  const [expanded, setExpanded] = useState(
    () =>
      getItem(STORAGE_NAMES.PEP_STUDY_RECRUITMENT_INSTRUCTIONS_EXPANDED) !==
      "0",
  );

  const instructionsExpandHandler = () => {
    setExpanded((prev) => {
      const newState = !prev;
      saveItem(
        STORAGE_NAMES.PEP_STUDY_RECRUITMENT_INSTRUCTIONS_EXPANDED,
        newState ? "1" : "0",
      );
      return newState;
    });
  };

  return (
    <MuiBox sx={boxStyles}>
      <MuiBox sx={{ position: "relative" }}>
        <MuiTypography sx={textStyles}>
          {expanded ? (
            <Trans
              i18nKey="studyRecruitment.instructions.expanded"
              components={{
                linkSCT: (
                  <MuiLink
                    key="smct"
                    href={INSTRUCTIONS_LINKS.SMCT}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: Theme.palette.primary.dark,
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  />
                ),
                linkSM: (
                  <MuiLink
                    key="sm"
                    href={INSTRUCTIONS_LINKS.SM}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: Theme.palette.primary.dark,
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  />
                ),
                linkSS: (
                  <MuiLink
                    key="spes"
                    href={INSTRUCTIONS_LINKS.SPES}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: Theme.palette.primary.dark,
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  />
                ),
                linkNIH: (
                  <MuiLink
                    key="nihct"
                    href={INSTRUCTIONS_LINKS.NIHCT}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: Theme.palette.primary.dark,
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  />
                ),
                linkEmail: (
                  <MuiLink
                    key="email"
                    href={INSTRUCTIONS_LINKS.EMAIL}
                    sx={{
                      color: Theme.palette.primary.dark,
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  />
                ),
              }}
            />
          ) : (
            <Trans
              i18nKey="studyRecruitment.instructions.minimized"
              components={{
                linkEmail: (
                  <MuiLink
                    key="email"
                    href={INSTRUCTIONS_LINKS.EMAIL}
                    sx={{
                      color: Theme.palette.primary.dark,
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  />
                ),
              }}
            />
          )}
        </MuiTypography>

        <MuiIconButton
          size="small"
          sx={{
            position: "absolute",
            bottom: -8,
            right: -8,
          }}
          onClick={instructionsExpandHandler}
        >
          {expanded ? (
            <MuiUnfoldLessIcon sx={{ fontSize: "24px" }} />
          ) : (
            <MuiUnfoldMoreIcon sx={{ fontSize: "24px" }} />
          )}
        </MuiIconButton>
      </MuiBox>
    </MuiBox>
  );
};

export default StudyRecruitmentInstructions;
